let globalImages = {
  sidebar_logo: require("../assets/images/r2f_logo.png"),
  advisor_bg: require("../assets/images/advisor_bg.png"),
  download: require("../assets/images/icons/common/download.svg").default,
};

let dashboard = {
  piggy_bank: require("../assets/images/piggy-bank.png"),
  check_icon: require("../assets/images/Vector-2.svg").default,
};

let funnelImages = {
  funnel_optin: require("../assets/images/funnel-optin.png"),
  funnel_checkout: require("../assets/images/funnel-checkout.png"),
  funnel_webinar: require("../assets/images/funnel-webinar.png"),
  funnel_thankyou: require("../assets/images/funnel-thankyou.png"),
};

let coursePageImages = {
  lock_icon: require("../assets/images/Group-40.jpg"),
  course_icon: require("../assets/images/Group-704.svg").default,
};

let errorPageImages = {
  error_404: require("../assets/images/not-found.svg").default,
  error_500: require("../assets/images/server-error.png"),
  error_403: require("../assets/images/error-403.png"),
  network_error: require("../assets/images/no-internet-error.png"),
  unauthorized: require("../assets/images/unauthorized.png"),
};

let promoteImages = {
  dummy: require("../assets/images/theme/img-1-1000x900.jpg"),
  income_history: require("../assets/images/income-history.png"),
  how_it_work_img1: require("../assets/images/how-it-work-img1.png"),
  how_it_work_img2: require("../assets/images/how-it-work-img2.png"),
  how_it_work_img3: require("../assets/images/how-it-work-img3.png"),
  initiate_earnings: require("../assets/images/initiate-earnings.png"),
  intro_background: require("../assets/images/theme/02_RTF_Bundle.png"),
};

let lessonImages = {
  arrow_down: require("../assets/images/arrow-down.png"),
};

let accountImages = {
  pingbank: require("../assets/images/piggy-bank.png"),
};

let adminCourseImages = {
  sortMenuDark: require("../assets/images/sort-menu-dark.png"),
  sortMenuLight: require("../assets/images/sort-menu-light.png"),
};

let challenges = {
  paperClip: require("../assets/images/icons/common/paperclip.svg").default,
  download: require("../assets/images/icons/common/download.svg").default,
  pause: require("../assets/images/icons/common/pause.svg").default,
  play: require("../assets/images/icons/common/play.svg").default,
  goldMedal: require("../assets/images/icons/common/gold-medal.svg").default,
  silverMedal: require("../assets/images/icons/common/silver-medal.svg")
    .default,
  bronzeMedal: require("../assets/images/icons/common/bronze-medal.svg")
    .default,
  crown: require("../assets/images/icons/common/crown.svg").default,
  crownGray: require("../assets/images/icons/common/crown-gray.svg").default,
  trophy: require("../assets/images/icons/common/trophy.png"),
};

let community = {
  communityLogo: require("../assets/images/icons/common/community.svg").default,
  bookmark: require("../assets/images/icons/common/bookmark.svg").default,
  bookmarkFilled: require("../assets/images/icons/common/bookmark-filled.svg")
    .default,
  comment: require("../assets/images/icons/common/comment.png"),
  commentFilled: require("../assets/images/icons/common/comment-filled.svg")
    .default,
  thumbsUp: require("../assets/images/icons/common/thumbs-up.svg").default,
  image: require("../assets/images/icons/common/image.png"),
  video: require("../assets/images/icons/common/video.png"),
  gif: require("../assets/images/icons/common/gif.png"),
  activity: require("../assets/images/icons/common/activity.png"),
  poll: require("../assets/images/icons/common/poll.png"),
  file: require("../assets/images/icons/common/file.png"),
  backgroundBeforeUpload:
    require("../assets/images/icons/common/background-before-upload.svg")
      .default,
};

let emojis = {
  like: require("../assets/images/icons/common/like.svg").default,
  love: require("../assets/images/icons/common/love.svg").default,
  haha: require("../assets/images/icons/common/haha.svg").default,
  wow: require("../assets/images/icons/common/wow.svg").default,
  sad: require("../assets/images/icons/common/sad.svg").default,
  angry: require("../assets/images/icons/common/angry.svg").default,
};

let activity = {
  feeling: require("../assets/images/icons/common/feeling.svg").default,
  traveling: require("../assets/images/icons/common/traveling.svg").default,
  watching: require("../assets/images/icons/common/watching.svg").default,
  playing: require("../assets/images/icons/common/playing.svg").default,
  listening: require("../assets/images/icons/common/listening.svg").default,
};

let notification = {
  checkSquare: require("../assets/images/icons/common/check-square.svg")
    .default,
};

let sidebar = {
  quickLink: require("../assets/images/icons/common/quick-link.svg").default,
  affiliateProgram: require("../assets/images/icons/common/affliate_button.png"),
};

export {
  globalImages,
  dashboard,
  funnelImages,
  coursePageImages,
  errorPageImages,
  promoteImages,
  lessonImages,
  accountImages,
  adminCourseImages,
  challenges,
  community,
  emojis,
  activity,
  notification,
  sidebar,
};
